import { render, staticRenderFns } from "./DynamicFieldsInfoTable.vue?vue&type=template&id=5572bd0f&scoped=true"
import script from "./DynamicFieldsInfoTable.vue?vue&type=script&lang=js"
export * from "./DynamicFieldsInfoTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5572bd0f",
  null
  
)

export default component.exports